import PropTypes from 'prop-types'
import { X, Info } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { getDaysOfTheMonth } from './helpers'

const ConfirmAutopaySetup = ({ isOpen, data, onClose, onSubmit }) => {
  const { t } = useTranslation(['organisation', 'common'])

  if (!isOpen) return null
  return (
    <div className="autopay-setup-dialog">
      <div className="overlay" />
      <div className="popup-content autopay-setup-dialog-popup">
        <div className="header">
          <div className="autopay-setup-dialog-popup-title">
            <div>{t('organisation:payments.confirmAutopaySetup.title')}</div>
          </div>
          <div onClick={onClose} className="header-cross-icon add-location-btn-cross">
            <X />
          </div>
        </div>
        <div className="body body-autopay-setup-dialog">
          <div className="content-wrapper">
            <div className="content-wrapper__header">
              {t('organisation:payments.confirmAutopaySetup.successMessage')}
            </div>
            <div className="flex-row-space">
              <div className="small-header">
                {t('organisation:payments.confirmAutopaySetup.paymentDateLabel')}
              </div>
              <div className="small-header">
                {getDaysOfTheMonth(t).find((day) => day.value === data.date)?.label}
              </div>
            </div>
            <div className="flex-row-space">
              <div className="small-header">
                {t('organisation:payments.confirmAutopaySetup.paymentAmountLabel')}
              </div>
              <div className="small-header">
                {t('organisation:payments.confirmAutopaySetup.amountDisplay', {
                  amount: data.amount,
                })}
              </div>
            </div>
            <div className="info-tip-desc">
              <Info size={40} style={{ position: 'relative', top: -9 }} />
              <div className="column-flex">
                <div className="info-tip-desc__title">
                  {t('organisation:payments.confirmAutopaySetup.turnOffOthersTitle')}
                </div>
                <div className="info-tip-desc__body">
                  {t('organisation:payments.confirmAutopaySetup.turnOffOthersBody')}
                </div>
              </div>
            </div>
          </div>
          <div className="body-actions">
            <button className="button button-gray" onClick={onClose}>
              {t('common:actions.cancel')}
            </button>
            <button className="button button-primary" onClick={onSubmit}>
              {t('organisation:payments.confirmAutopaySetup.submitButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

ConfirmAutopaySetup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
}

export default ConfirmAutopaySetup
